import React from 'react'
import FollowingEventsFlow from './FollowingEventsFlow'
import TeacherCalendarCancellationFirstPopup from './TeacherCalendarCancellationFirstPopup'
import TeacherCancellationForm from './TeacherCancellationForm'
import ThisEventFlow from './ThisEventFlow'
import StudentDiscontinuationForm from './StudentDiscontinuationForm'

const TeacherCalendarCancellationFlow = ({open, setOpen, event, setAllEvents, socket, setOpenEvent}) => {
    const [firstPopup, setFirstPopup] = React.useState(true)
    const [thisEventFlow, setThisEventFlow] = React.useState(false)
    const [followingEventsFlow, setFollowingEventsFlow] = React.useState(false)
    const [teacherCancellationForm, setTeacherCancellationForm] = React.useState(false)
    const [studentDiscontinuationForm, setStudentDiscontinuationForm] = React.useState(false)


    return (
        <div>
            <TeacherCalendarCancellationFirstPopup open={firstPopup} setOpen={setFirstPopup} abortCancellationFlow={setOpen}  thisEventFlow={thisEventFlow} setThisEventFlow={setThisEventFlow} setFollowingEventsFlow={setFollowingEventsFlow} />
            {thisEventFlow && <ThisEventFlow open={thisEventFlow} setOpen={setThisEventFlow} setTeacherCancellationForm={setTeacherCancellationForm} abortCancellationFlow={setOpen} />}
            {followingEventsFlow && <FollowingEventsFlow open={followingEventsFlow} setOpen={setFollowingEventsFlow} abortCancellationFlow={setOpen} event={event} setStudentDiscontinuationForm={setStudentDiscontinuationForm} />}
            {teacherCancellationForm && <TeacherCancellationForm event={event} abortCancellationFlow={setOpen} setAllEvents={setAllEvents} socket={socket} setOpenEvent={setOpenEvent} />}
            {studentDiscontinuationForm && <StudentDiscontinuationForm open={studentDiscontinuationForm} setOpen={setStudentDiscontinuationForm} event={event} abortCancellationFlow={setOpen} setAllEvents={setAllEvents} setOpenEvent={setOpenEvent} socket={socket} />}
        </div>
      ) 
}
export default TeacherCalendarCancellationFlow